<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right">
    <h6 slot="header" class="modal-title text-success font-weight-bold" id="modal-title-default">
      Login User E-BPHTB Online
    </h6>
    <div class="d-block">
      <b-tabs content-class="mt-3" fill>
        <b-tab title="PPAT - WP - BPHTB">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form ref="form" @submit.stop.prevent="handleSubmit(login)">
              <div class="mb-5">
                <div class="container pt-lg-md">
                  <div class="row justify-content-center">
                    <div class="col-lg-12">
                      <template>
                        <base-input alternative class="mb-3" v-model="form.email" placeholder="Email"
                          addon-left-icon="ni ni-email-83"></base-input>
                        <base-input alternative type="password" v-model="form.password" placeholder="Password"
                          addon-left-icon="ni ni-lock-circle-open"></base-input>
                        <div class="text-center">
                          <template v-if="isBusy">
                            <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                            <strong>Loading...</strong>
                          </template>
                          <base-button v-else type="primary" nativeType="submit" icon="ni ni-send" class="my-4">Log In
                          </base-button>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </b-tab>
      </b-tabs>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import qs from "qs";
import axios from "axios";
import Swal from "sweetalert2";
import { BTabs, BTab } from "bootstrap-vue";

export default {
  components: {
    Modal,
    PulseLoader,
    ValidationProvider,
    ValidationObserver,
    BTabs,
    BTab,
  },
  data() {
    return {
      modals: {
        modal1: false,
      },
      form: {
        npwpd: null,
        email: null,
        password: null,
      },
      isBusy: false,
    };
  },
  methods: {
    showModal() {
      this.form.npwpd = null;
      this.form.password = null;
      this.form.email = null;
      this.modals.modal1 = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
    async login() {
      const me = this;
      try {
        this.isBusy = true;
        let { data, status } = await axios.post(
          "/api/v1/user/login",
          qs.stringify(me.form)
        );

        if (status >= 200 && status <= 202) {
          this.$store.dispatch("auth/login", data);
          Swal.fire({
            title: "",
            text: "Login Berhasil.",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Tutup!",
          }).then(() => {
            me.hideModal();
          });
        }
      } catch (error) {
        // console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}
</style>